var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewReorder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_21_64)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 0.5,
    width: 67,
    height: 67,
    rx: 11.5,
    fill: "#3EC6CA",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 48.4375C14 45.9842 14 44.7575 14.4823 43.8437C14.7983 43.2452 15.2527 42.7481 15.8 42.4026C16.6354 41.875 17.7569 41.875 20 41.875C22.2431 41.875 23.3646 41.875 24.2 42.4026C24.7473 42.7481 25.2017 43.2452 25.5177 43.8437C26 44.7575 26 45.9842 26 48.4375C26 50.8908 26 52.1175 25.5177 53.0312C25.2017 53.6297 24.7473 54.1269 24.2 54.4724C23.3646 55 22.2431 55 20 55C17.7569 55 16.6354 55 15.8 54.4724C15.2527 54.1269 14.7983 53.6297 14.4823 53.0312C14 52.1175 14 50.8908 14 48.4375Z",
    fill: "#3EC6CA",
    stroke: "white",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 48.4375C32 45.9842 32 44.7575 32.4823 43.8437C32.7983 43.2452 33.2528 42.7481 33.8 42.4026C34.6354 41.875 35.757 41.875 38 41.875C40.243 41.875 41.3646 41.875 42.2 42.4026C42.7472 42.7481 43.2018 43.2452 43.5176 43.8437C44 44.7575 44 45.9842 44 48.4375C44 50.8908 44 52.1175 43.5176 53.0312C43.2018 53.6297 42.7472 54.1269 42.2 54.4724C41.3646 55 40.243 55 38 55C35.757 55 34.6354 55 33.8 54.4724C33.2528 54.1269 32.7983 53.6297 32.4823 53.0312C32 52.1175 32 50.8908 32 48.4375Z",
    fill: "#3EC6CA",
    stroke: "white",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 48.4375C50 45.9842 50 44.7575 50.4824 43.8437C50.7982 43.2452 51.2528 42.7481 51.8 42.4026C52.6354 41.875 53.757 41.875 56 41.875C58.243 41.875 59.3646 41.875 60.2 42.4026C60.7472 42.7481 61.2018 43.2452 61.5176 43.8437C62 44.7575 62 45.9842 62 48.4375C62 50.8908 62 52.1175 61.5176 53.0312C61.2018 53.6297 60.7472 54.1269 60.2 54.4724C59.3646 55 58.243 55 56 55C53.757 55 52.6354 55 51.8 54.4724C51.2528 54.1269 50.7982 53.6297 50.4824 53.0312C50 52.1175 50 50.8908 50 48.4375Z",
    fill: "#3EC6CA",
    stroke: "white",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 41.875V26.125C20 19.9378 20 16.8442 21.7574 14.9221C23.5147 13 26.3432 13 32 13H34.4M44 13C49.6568 13 52.4852 13 54.2427 14.9221C56 16.8442 56 19.9378 56 26.125V34M56 34L60.8 28.75ZM56 34L51.2 28.75Z",
    fill: "#3EC6CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 41.875V26.125C20 19.9378 20 16.8442 21.7574 14.9221C23.5147 13 26.3432 13 32 13H34.4M44 13C49.6568 13 52.4852 13 54.2427 14.9221C56 16.8442 56 19.9378 56 26.125V34M56 34L60.8 28.75M56 34L51.2 28.75",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_21_64",
    x: 0,
    y: 0,
    width: 76,
    height: 76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_21_64"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_21_64",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewReorder);
export default __webpack_public_path__ + "static/media/newReorder.8e69dd064e83cd8594fbdae797ce953e.svg";
export { ForwardRef as ReactComponent };